import { Component } from '@angular/core';

@Component({
  selector: 'sin-retos',
  templateUrl: 'sin-retos.html'
})
export class SinRetosComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/sin-retos/sin-retos.ts